import React, { useState } from "react";
import Modal from "../../components/Modal";
import { RotatingLines } from "react-loader-spinner";
import { toast } from "react-toastify";
import { useAuth } from "../../context/Auth";
import Swal from "sweetalert2";

const InterbranchDetails = ({ modalOpen, setModalOpen, transfer }) => {
  return (
    <div>
      <Modal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Credit Sale Details"
      >
        <h4>Items Transfered</h4>
        <table>
          <thead>
            <tr>
              <th className="text-left">Item Name</th>
              <th className="text-left">Quantity</th>
              <th className="text-left">Price</th>
            </tr>
          </thead>
          <tbody>
            {transfer?.items?.map((item, index) => (
              <tr key={index}>
                <td>{item?.drug}</td>
                <td>{item?.quantity}</td>
                <td>{item?.total_cost}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal>
    </div>
  );
};

export default InterbranchDetails;
